import requestAction from '../../utils/requestAction'

export const downloadPreorderFile = (preorderId: number, fileId?: string, handleResponse?: (file: any) => void) =>
  requestAction('COMPLAINT_MESSAGE_DOWNLOADFILE')(
    `preorders/download?preorderId=${preorderId}${fileId ? '&fileId=' + fileId : ''}`,
    'GET',
    undefined,
    {
      'Accept': 'application/pdf',
      'Content-Type': 'application/pdf',
    },
    'file',
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response) })

